import React from 'react';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Para quién es este material?',
  a: 'Está diseñado específicamente para docentes de grado, directivos, equipos de orientación escolar (EOE) y preceptores de nivel primario (1° a 7° grado) de Argentina.'
}, {
  q: '¿Cómo recibo el pack?',
  a: 'Inmediatamente después de confirmar el pago, recibís un email automático con el link de descarga. Podés bajarlo a tu computadora, tablet o celular en menos de 5 minutos.'
}, {
  q: '¿El material es editable?',
  a: 'Recibís archivos PDF de alta calidad listos para imprimir y usar. Las actas y modelos de notas están diseñados con espacios claros para completar a mano o podés copiar el texto a tu procesador favorito.'
}, {
  q: '¿Sirve para escuelas secundarias?',
  a: "Este pack está adaptado específicamente a la psicología y realidad de chicos de 6 a 12 años. Para secundaria, recomendamos nuestra versión 'Nivel Secundario'."
}];
export function FAQ() {
  return <section className="bg-white py-6 md:py-12 lg:py-[60px]" id="faq" data-id="element-34">
      <div className="container mx-auto px-4" data-id="element-35">
        <h2 className="text-[#1B3A6B] font-poppins font-black text-3xl md:text-5xl text-center mb-5 md:mb-6 lg:mb-8" data-id="element-36">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="max-w-3xl mx-auto space-y-3" data-id="element-37">
          {faqs.map((f, i) => <details key={i} className="group bg-[#F5F5F5] rounded-xl overflow-hidden" data-id="element-38">
              <summary className="flex items-center justify-between px-5 py-3 md:py-4 cursor-pointer font-bold text-[#1B3A6B] list-none" data-id="element-39">
                {f.q}
                <ChevronDown size={20} className="text-[#FF6B35] group-open:rotate-180 transition-transform" data-id="element-40" />
              </summary>
              <div className="px-5 pb-4 text-[#2C2C2C] leading-relaxed" data-id="element-41">
                {f.a}
              </div>
            </details>)}
        </div>
      </div>
    </section>;
}